import React from 'react'

import { generatePath, useHistory, useParams } from 'react-router-dom'

import { Container, LoadingFeedback, Page } from 'components'
import AiInventoryForm from 'views/AiInventory/components/AiInventoryForm'

import useAuthGuest from 'hooks/useAuthGuest'
import useFetch from 'hooks/useFetch'

import * as service from 'service'
import { routes } from 'GuestRoutes'

const GUEST_STEPS = [
  'Informações Gerais',
  'Finalidade',
  'Detalhamento',
  'Resumo',
]

const AiInventoryShow = () => {
  const history = useHistory()
  const { aiInventoryId, organizationSlug } = useParams()
  const { user } = useAuthGuest()

  const { response, isLoading, refresh } = useFetch(
    service.guestPortal.aiInventory.show,
    aiInventoryId,
    [aiInventoryId],
  )

  const aiInventory = response?.data?.aiInventoryItem || null

  return (
    <Page title="Visualizar Inventário de IA">
      <Container maxWidth={false}>
        <LoadingFeedback open={isLoading} />
        {aiInventory && (
          <AiInventoryForm
            mode="show"
            aiInventory={aiInventory}
            steps={GUEST_STEPS}
            guestMode
            currentDepartmentId={user?.departmentId || null}
            toolsService={service.guestPortal.aiInventoryTools.get}
            departmentsService={service.guestPortal.departments.get}
            purposesService={service.guestPortal.aiInventoryPurposes}
            onStepSubmit={() => {}}
            onAiInventoryRefresh={refresh}
            onBack={() =>
              history.push(
                generatePath(routes.aiInventory.list, { organizationSlug }),
              )
            }
          />
        )}
      </Container>
    </Page>
  )
}

export default AiInventoryShow
